(function($) {
	
	$('.on-page-nav__toggle').on('click', function(e){
		$('.on-page-nav__content').toggle().parents('.block--on-page-nav').toggleClass('is-open');
	})
	
	
})( jQuery );